import script from "./TheFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFilters.vue?vue&type=script&setup=true&lang=js"

import "./TheFilters.vue?vue&type=style&index=0&id=270d1f53&lang=scss"

const __exports__ = script;

export default __exports__